/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-param-reassign */
/* eslint-disable import/no-extraneous-dependencies */
import axios from 'axios';
import {
  Observable, of, pipe, from, forkJoin,
} from 'rxjs';
import {
  catchError,
  map,
  shareReplay,
} from 'rxjs/operators';
import { ContextService } from '@/services/ContextService';
import CapabilitiesParser from '../models/CapabilitiesParser';
import CapabilitiesResponse from '@/models/CapabilitiesResponse';

class CapabilitiesService {
  // cache des reponses aux appels des getcapabilities
  wmtsCapabilitiesCache: any = {};

  wmtsCapabilitiesPendingRequest: any = {};

  contextService!:ContextService;

  parser = new CapabilitiesParser();
  constructor(contextService:ContextService) {
    this.contextService = contextService;
  }
  
  getRecords(url: string, headers: any = {}): Observable<any> {
    return from(axios.get(url, { headers, responseType: 'text' })).pipe(
      catchError((error) => {
        console.log(error);
        if (error.message === 'Network Error' && url.indexOf('/proxy') < 0) {
          console.log('Retry with proxy');
          console.log('Error:retry with proxy');
          const proxyfiedUrl = this.contextService.getProxyFiedUrl(url);
          return from(axios.get(proxyfiedUrl, { headers, responseType: 'text' })).pipe(
            map((reponse:any) => {
              console.log(reponse);
              reponse.useProxy = true;
              return reponse;
            }),
          );
        }
        return of(`I caught: ${error}`);
      }),
    ).pipe(
      map((reponse:any) => {
        console.log(reponse);
        const capabilities = this.parser.parseRecords(reponse.data, url);
        capabilities.useProxy = reponse.useProxy;
        return capabilities;
      }),
    );
  }

  getCapabilities(url: string, headers: any = {}, usecache = true): Observable<any> {
    if (usecache && this.wmtsCapabilitiesCache[url]) {
      return of(this.wmtsCapabilitiesCache[url]);
    }
    if (this.wmtsCapabilitiesPendingRequest[url]) {
      console.log(`reuse observable for ${url}`);
      return this.wmtsCapabilitiesPendingRequest[url];
    }
    console.log(`create observable for ${url}`);
    this.wmtsCapabilitiesPendingRequest[url] = from(axios.get(url, { headers, responseType: 'text' })).pipe(
      catchError((error) => {
        console.log(error);
        this.wmtsCapabilitiesPendingRequest[url] = undefined;
        if (error.message === 'Network Error' && url.indexOf('/proxy') < 0) {
          console.log('Retry with proxy');
          console.log('Error:retry with proxy');
          const proxyfiedUrl = this.contextService.getProxyFiedUrl(url);
          return from(axios.get(proxyfiedUrl, { headers, responseType: 'text' }))
           .pipe( 
            map((reponse:any) => {
              console.log(reponse);
              reponse.useProxy = true;
              return reponse;
            }),
          ).pipe(
            catchError((error) => {
              console.error(error);
            throw new Error('Erreur CORS puis erreur avec le proxy <br>'+proxyfiedUrl+'<br>'+error.message);   
          }));
        }
        return of(`I caught: ${error}`);
      }),
    ).pipe(
      map((reponse:any) => {
        console.log(reponse);
        this.wmtsCapabilitiesPendingRequest[url] = undefined;
        if(reponse.data){
          const capabilities = new CapabilitiesResponse(this.parser.parse(reponse.data, url));
          capabilities.useProxy = reponse.useProxy;
          this.wmtsCapabilitiesCache[url] = capabilities;
          return capabilities;
        }
        else{
          throw new Error('Impossible de lire la réponse du GetCapabilities'+url); 
          //return null;
        }
      }),
      shareReplay(1),
    );
    return this.wmtsCapabilitiesPendingRequest[url];
  }

  checkLayerExists(url: string, headers: any = {}): Observable<boolean> {
    return this.checkLayerExistsWithoutProxy(url, headers).pipe(
      catchError((error) => {
        console.log("Error while accessing layer without proxy:", error);
        console.log("Retry with proxy")
        return this.checkLayerExistsWithProxy(url, headers);
      })
    );
  }

  checkLayerExistsWithoutProxy(url: string, headers: any = {}): Observable<boolean> {
    return from(axios.get(url, { headers, responseType: 'text' })).pipe(
      map(() => true),
      catchError((error) => {
        console.log("Access layer without prxy failed:", error);
        return of(false);
      })
    );
  }

  checkLayerExistsWithProxy(originalUrl: string, headers: any = {}): Observable<boolean> {
    const proxyUrl = this.contextService.getProxyFiedUrl(originalUrl);
    return from(axios.get(proxyUrl, { headers, responseType: 'text' })).pipe(
      map(() => true),
      catchError((proxyError) => {
        console.error("Access layer with prxy failed:", proxyError);
        return of(false);
      })
    );
  }

  parseWMC(data: any):Observable<any> {
    const parser = new CapabilitiesParser();
    const appConfig = parser.parseWMC(data);
    const calls:Observable<any>[] = [];
    appConfig.layers.forEach((layer:any) => {
      const currentLayer = layer;
      if (currentLayer.type === 'WMS') {
        const capabilitiesObservable = this.getCapabilities(this.getCapabilitiesUrl(layer.url))
          .pipe(map((response:any) => {
            console.log(response);

            const selectedLayer = response.layers
              .find((x:any) => x.Name === currentLayer.layername);
            if (selectedLayer) {
              const bbox = selectedLayer.EX_GeographicBoundingBox;
              for (let i = 0; i < bbox.length; i += 1) {
                bbox[i] = +bbox[i].toFixed(3);
              }
              currentLayer.boundingBoxEPSG4326 = bbox;
            }
            return appConfig;
          }))
          .pipe(
            catchError((err) => of(appConfig)),
          );
        calls.push(capabilitiesObservable);
      }
    });
    // wait for all observable and send back first response as
    // they are all the same

    return forkJoin(calls).pipe(map((response:any) => response[0]));
  }

  getCapabilitiesUrl(url:string): string {
    const searchMask = 'getCapabilities';
    const regEx = new RegExp(searchMask, 'ig');
    if (regEx.test(url)) {
      return url;
    }
    return `${url}&request=getCapabilities`;
  }
}

export default CapabilitiesService;
export { CapabilitiesService };
